// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2379":"e3304a11b68203f1","2888":"ed26c2353bdeab54","9652":"e1fa8eda8e4801b0"}[chunkId] + ".css";
};